import React from 'react';
import {Users} from 'lucide-react';
import ParticipantItem from './ParticipantItem';

const ParticipantsList = ({
                              participants,
                              userId,
                              myChannel,
                              isMuted,
                              otherParticipantMuted,
                              isCallConnected
                          }) => {
    return (
        <div>
            <div className="flex items-center gap-2 mb-3">
                <Users className="w-4 h-4 text-zinc-400"/>
                <h3 className="text-xs sm:text-sm font-semibold text-zinc-300 uppercase tracking-wider">
                    Participants ({participants.length})
                </h3>
            </div>
            <div className="text-xs text-zinc-500 mb-3">
                Active participants • Channel assignments
            </div>
            <div className="space-y-2">
                {participants.length === 0 ? (
                    <div className="glass-panel p-4 rounded-lg text-center text-zinc-500 text-sm">
                        <Users className="w-8 h-8 mx-auto mb-2 text-zinc-600"/>
                        <p>No participants yet</p>
                    </div>
                ) : (
                    participants.map((p) => {
                        const isMe = p.id === userId;
                        const participantMuted = isMe ? isMuted : otherParticipantMuted;
                        return (
                            <ParticipantItem
                                key={p.id}
                                participant={p}
                                isMe={isMe}
                                channel={isMe ? myChannel : (myChannel !== null ? (1 - myChannel) : null)}
                                isMuted={participantMuted}
                                isCallConnected={isCallConnected}
                            />
                        );
                    })
                )}
            </div>
        </div>
    );
};

export default ParticipantsList;
